var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0627 5.1126C15.0627 7.38442 13.2207 9.2252 10.9501 9.2252C8.67829 9.2252 6.8363 7.38442 6.8363 5.1126C6.8363 2.84077 8.67829 1 10.9501 1C13.2207 1 15.0627 2.84077 15.0627 5.1126Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9816 12.2305C14.0116 12.2227 16.588 13.614 17.535 16.6089C15.6262 17.7725 13.3794 18.2207 10.9816 18.2148C8.58376 18.2207 6.33691 17.7725 4.4281 16.6089C5.3762 13.6108 7.94824 12.2227 10.9816 12.2305Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5946 11.3804C3.47024 11.375 1.66395 12.3504 1.00001 14.45C1.7247 14.8918 2.51888 15.1865 3.36173 15.3632",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72397 3.72767C5.25403 3.11649 3.5661 3.81235 2.95459 5.28308C2.34309 6.7538 3.04007 8.44127 4.51 9.05245C5.72348 9.55699 7.08483 9.17152 7.86742 8.19513",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4056 11.3804C18.53 11.375 20.3363 12.3504 21.0002 14.45C20.2755 14.8918 19.4814 15.1865 18.6385 15.3632",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1062 8.16018C15.0837 9.41773 16.8954 9.6441 18.1529 8.66658C19.4098 7.68959 19.6374 5.87808 18.6598 4.62053C17.788 3.49897 16.2527 3.19763 15.0392 3.83867",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUsers);
export default __webpack_public_path__ + "static/media/multiUsers.0d4b15c22fe95965a3cb7605168ac00f.svg";
export { ForwardRef as ReactComponent };